import { ENGLISH_IQ_SUB_BANDS } from '@repo/config';
import { ASSESSMENT_BENCHMARK_SLOT_PLAN } from '../constants';
import { createAssessmentSingleSkillSlotPlan } from '../plans';
import type { AssessmentSkillType, IAssessmentCandidate } from '../types';
import {
  type IAssessmentSupplyIssue,
  simulateAssessmentCandidateSupply,
} from './simulate-assessment-candidate-supply';

export function validateAssessmentCandidateSupply(candidates: readonly IAssessmentCandidate[]): {
  issues: IAssessmentSupplyIssue[];
  valid: boolean;
} {
  const skills: AssessmentSkillType[] = ['grammar', 'meaning', 'listening'];
  const plans = [
    { id: 'benchmark', slots: ASSESSMENT_BENCHMARK_SLOT_PLAN },
    ...skills.map((skill) => ({
      id: `skill:${skill}`,
      slots: createAssessmentSingleSkillSlotPlan(skill),
    })),
  ];
  const issues = ENGLISH_IQ_SUB_BANDS.flatMap((band) => {
    const score = Math.round((band.minScore + band.maxScore) / 2);
    return plans.flatMap(({ id, slots }) =>
      simulateAssessmentCandidateSupply(candidates, score, slots, id),
    );
  });
  const uniqueIssues = [
    ...new Map(
      issues.map((issue) => [
        `${issue.plan}:${issue.score}:${issue.skill}:${issue.renderer}`,
        issue,
      ]),
    ).values(),
  ];
  return { issues: uniqueIssues, valid: uniqueIssues.length === 0 };
}
